<template>
  <div class="bg-white p-2">
    <div class="d-flex justify-content-between">
      <h4>Danh sách Điện thoại viên</h4>
      <!--      <div>-->
      <!--        <div class="btn btn-primary" id="alert-comming-call">Có 12 cuộc gọi đang chờ!!</div>-->
      <!--        <button class="btn btn-primary ml-2">Thêm nhân viên</button>-->
      <!--      </div>-->
      <p>
        <b class="text-primary font-medium-4"> {{ numberDTV }}</b> TDV online
      </p>
    </div>
    <table class=" mt-2 table table-bordered">
      <thead>
        <tr class="text-center tab">
          <th>STT</th>
          <th>User CRM</th>
          <th>User phê duyệt</th>
          <th>Trạng thái</th>
          <th>Tùy chọn</th>
        </tr>
      </thead>
      <tbody class="table-group-divider">
        <tr v-for="(user, index) in listDTV">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ user.nickname }}</td>
          <td></td>
          <td class="text-center">
            <button class="btn btn-primary" v-if="user.isAcceptCall">
              Đang bận
            </button>
            <button class="btn btn-success" v-else>
              Sẵn sàng
            </button>
          </td>
          <td class="text-center">
            <!--          <button class="btn btn-primary">-->
            <!--            <feather-icon icon="Edit3Icon"  size="16"/>-->
            <!--        </button>-->
          </td>
        </tr>
      </tbody>
    </table>
    <b-modal id="add-user-modal" hide-footer title="Thêm nhân viên">
      <p>User CRM</p>
      <Select2 />
      <p class="mt-1">User phê duyệt</p>
      <b-form-input class=" form-control"></b-form-input>
      <div class="d-flex justify-content-end mt-2">
        <button class="btn btn-primary">Lưu</button>
        <button class="btn btn-secondary ml-2">Hủy</button>
      </div>
    </b-modal>
    <b-modal id="change-status-modal" hide-footer title="Trạng thái mới">
      <p>Trạng thái</p>
      <Select2 />
      <div class="d-flex justify-content-end mt-2">
        <button class="btn btn-primary">Lưu</button>
        <button class="btn btn-secondary ml-2">Hủy</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BFormInput } from "bootstrap-vue";
import Select2 from "v-select2-component";
import axios from "axios";
import { $ctx } from "@themeConfig";

export default {
  name: "QuanLyDTV",
  components: { BFormInput, Select2 },
  data() {
    return {
      listDTV: [],
      intervalFetch: null,
      socketURL: $ctx.API_URL.includes("dev")
        ? "https://socket.itel.dev/"
        : "https://socket.itel.vn/",
      numberDTV: 0
    };
  },
  mounted() {
    this.getListDTV();
    this.intervalFetch = setInterval(() => {
      this.getListDTV();
    }, 10000);
    // this.$bvModal.show('change-status-modal')
  },
  beforeDestroy() {
    clearInterval(this.intervalFetch);
  },
  methods: {
    getListDTV() {
      axios
        .get(this.socketURL + "teller")
        .then(res => {
          this.listDTV = res.data.teller;
          this.numberDTV = res.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
#alert-comming-call {
  animation: Alert-Call-animation 2s infinite;
}
@keyframes Alert-Call-animation {
  0% {
    scale: 1;
    rotate: 0deg;
  }
  25% {
    scale: 1.5;
    rotate: 10deg;
  }
  50% {
    scale: 1;
    rotate: 0deg;
  }
  75% {
    scale: 1.5;
    rotate: -10deg;
  }
  100% {
    scale: 1;
    rotate: 0deg;
  }
}
</style>
